export default __webpack_public_path__ + "static/media/3.78dc7862.jpeg";